// extracted by mini-css-extract-plugin
module.exports = {"videoPlayerNoHlsStub":"VideoPlayerNoHlsStub_videoPlayerNoHlsStub__1APVd","defaultBound":"VideoPlayerNoHlsStub_defaultBound__3Q-0P"};